import React, { Component } from 'react';
import { WithStyles, InputAdornment, Popover } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button,Tooltip, Select, ListSubheader, Chip, Input, MenuItem, Checkbox, ListItemText } from '@material-ui/core';
import { MyPATTextField, MyPATTextArea, MyPATSelect } from '../../../common';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import Switch from '@material-ui/core/Switch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import TagsContent from "../AdvancedSetting/TagsContent"
import BatchesSyllabusContent from "../AdvancedSetting/BatchesSyllabusContent"
import _ from 'lodash';
import cx from 'classnames';
import { bindActionCreators } from 'redux';
import { showMsg } from '../../actions/loaderAlert';
import advancedSettingService from '../../services/advancedSettingService';
import dateService from '../../../common/services/dateService';
import { setCourseData } from "../../actions/courseSetData"
import { getCourseID } from '../CourseDetail/commonFunction';
import { styles } from '../../styling/component/AdvanceSetting/AdvanceSettingContent'
import DateIcon from '@material-ui/icons/DateRange';
import { Batch } from '../../modals/AdvanceMilestone';
import ResponseBasedACL from '../../../acl/components/ResponseBasedACL';
import TemplateSetting from '../../../test-template/components/TemplateSetting';

import { getTestTemplateType } from '../../../test-template/actions/testTemplateActions';
import { ContentSubType } from '../../../test-template/types/ContentSubTypeBody';

interface AdvanceSettingProps extends WithStyles<typeof styles> {
	showMsg: (msg: string, vari: string) => void;
	setCourseData: Function;
	previewMode: boolean,
	courseID: string,
	setAddedBatchesData: Function,
	toggleInstructorBatchCard: Function,
	instructorKey:any,
	instructorValue:any,
	cardDetails: any,
	batchesData: Batch[],
	cardFlag: any,
	setCountSubjectRemove:any,
	subjectRemoved:number,
	getTestTemplateType: Function,
	testTemplateTypeList: ContentSubType[],

}

interface AdvanceSettingStates {
	checkPublish: boolean,
	checkAutoLogin: boolean,
	coursePrice: string,
	paidStatus: string,
	selectedTestTypeName: string;
	purchaseStartDate: string,
	purchaseEndDate: string,
	languageSelected: string,
	courseDescription: string,
	batchesData: Batch[],
	anchorEl: null,
	setCourseData: boolean,
	tags:[],
	mandatoryTags: any,
	autoAssign: any
	testTypes: string[],
	isTestTypeOpen: boolean,
}

class AdvanceSettingContent extends Component<AdvanceSettingProps, AdvanceSettingStates> {
	constructor(props: AdvanceSettingProps) {
		super(props);

		let currentDate = new Date()
		this.state = {
			checkPublish: false,
			coursePrice: "",
			paidStatus: "Free",
			purchaseStartDate: new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 16),
			purchaseEndDate: "",
			languageSelected: "",
			courseDescription: "",
			selectedTestTypeName: "",
			checkAutoLogin: false,
			batchesData: [],
			anchorEl: null,
			setCourseData: false,
			tags:[],
			mandatoryTags:'',
			autoAssign: false,
			testTypes: [],
			isTestTypeOpen: false,
		}
		this.setAddedBatchesData = this.setAddedBatchesData.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.validateSettings = this.validateSettings.bind(this)
		this.getMandatoryTagsData = this.getMandatoryTagsData.bind(this)
		this.settingUpdate = this.settingUpdate.bind(this)
		this.getMandatoryTags = this.getMandatoryTags.bind(this)

		this.handleTestTypeChange = this.handleTestTypeChange.bind(this);
		this.handleTestTypeOpen = this.handleTestTypeOpen.bind(this);
		this.handleTestTypeClose = this.handleTestTypeClose.bind(this);
	}

	componentDidUpdate() {
		this.settingUpdate()

	}
	componentWillMount(){
		this.getMandatoryTags()
	}

	componentDidMount() {
		if(_.isEmpty(this.props.testTemplateTypeList)) {
			this.props.getTestTemplateType("testpapers");
		}
	}

	settingUpdate = () => {
		let { setting,price } = this.props.cardDetails
		let { setCourseData } = this.state
		let autoAssign = ""
		if( setting !== undefined ){
			let { 
				isPublish, 
				isPayable, 
				courseDescription,
				purchaseStartDate, 
				purchaseEndDate,
				language,
				tags } = setting

			if(setting.autoAssign){
				autoAssign = setting.autoAssign;
			 }
			purchaseStartDate = dateService.dateISOtoYMD(purchaseStartDate)
			purchaseEndDate = dateService.dateISOtoYMD(purchaseEndDate)

			if( !setCourseData ){
				this.setState({
					checkPublish: isPublish,
					paidStatus: isPayable ? 'Paid' : 'Free',
					purchaseStartDate: purchaseStartDate,
					purchaseEndDate: purchaseEndDate !== null ? purchaseEndDate : "",
					courseDescription: courseDescription,
					languageSelected: language !== null ? language : "",
					coursePrice: price !== null ? price : "",
					setCourseData: true,
					autoAssign: autoAssign != "" ? autoAssign : false,
					tags
				});
			}
			

		}
	}	

	handleClick = async (event: any) => {
		this.setState({ anchorEl: event.currentTarget });
	}

	handleClose = async () => {
		this.setState({ anchorEl: null });
	}

	handleChangePublish = async (event: any) => {
		this.setState({
			checkPublish: event.target.checked
		})
	}

	handleEnableLogin = async (event: any) => {
		this.setState({
			checkAutoLogin: event.target.checked,
			autoAssign: event.target.checked,
		})
	}

	handleChangePaidStatus = async (event: any) => {
		this.setState({
			paidStatus: event.target.value
		})
	}

	handlePriceChanges(event: any) {
		this.setState({
			coursePrice: event.target.value
		})
	}

	handleLanguageChange(event: any) {
		this.setState({
			languageSelected: event.target.value
		})
	}

	handleStartDateChange(event: any) {
		this.setState({
			purchaseStartDate: event.target.value
		})
	}

	handleEndDateChange(event: any) {
		this.setState({
			purchaseEndDate: event.target.value
		})
	}

	handleDescriptionChange(event: any) {
		this.setState({
			courseDescription: event.target.value
		})
	}

	setAddedBatchesData(addedBatches: any) {
		this.setState({
			batchesData: addedBatches
		})
		this.props.setAddedBatchesData(addedBatches)
	}

	validateSettings() {
		let { courseDescription, coursePrice, purchaseEndDate, purchaseStartDate, languageSelected, paidStatus } = this.state;
		let self = this;

		if (coursePrice === '' && paidStatus == "Paid") {
			self.props.showMsg('Please enter course price.', 'error');
			return false;
		}

		if (purchaseEndDate === '' && paidStatus == "Paid") {
			self.props.showMsg('Please select purchase end date.', 'error');
			return false;
		}

		if (purchaseStartDate === '' && paidStatus == "Paid") {
			self.props.showMsg('Please select purchase start date.', 'error');
			return false;
		}

		if (languageSelected === '') {
			self.props.showMsg('Please select language.', 'error');
			return false;
		}

		if (courseDescription=== '') {
			self.props.showMsg('Please enter course description.', 'error');
			return false;
		}
		return true
	}
	getMandatoryTags() {
		let self = this
		advancedSettingService.getMandatoryTags().then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData.length > 0) {
				self.setState({
					mandatoryTags: responseData
				})
			}
		});
	}
	getMandatoryTagsData(event: any, flag: string) {
		var {setCourseData,tags,mandatoryTags} = this.state
		var getLength = document.getElementsByClassName(flag).length
		let tagArray : any = []
		var self = this;

		for (var i = 0; i < getLength; i++) {
			var getElement = document.getElementById(flag + i) || event.currentTarget
			var getType = getElement.getAttribute("data-type")
			switch (getType) {
				case "checkboxOptions":
					
					var getElement = document.getElementById(flag + i) || event.currentTarget

					var getName = getElement.getAttribute("data-name")
					var getID = getElement.getAttribute("data-id")
					let checkboxValue = (document.getElementById(`hdn_${getID}`) as HTMLInputElement).value;

					if (checkboxValue != "") {
						tagArray.push({
							"_id": getID,
							"tagName": getName,
							"value": checkboxValue.split(","),
							"tagType": getType
						})
					}
					else if(setCourseData){
						mandatoryTags.forEach((mt:any,i:number)=>{
							tags.forEach((t:any,i:number)=>{
								
							if(mt._id === t._id && mt.content.type == getType){
								tagArray.push({
									"_id": t._id,
									"tagName": t.tagName,
									"value": t.value,
									"tagType": getType
								})
							}
						
							})
						})
						
					}
					break;

				case "radioOptions":
					var getElement = document.getElementById(flag + i) || event.currentTarget

					var getName = getElement.getAttribute("data-name")
					var getID = getElement.getAttribute("data-id")
					let radioValue = (document.getElementById(`hdn_${getID}`) as HTMLInputElement).value;

					if (radioValue != "") {
						tagArray.push({
							"_id": getID,
							"tagName": getName,
							"value": radioValue.split(","),
							"tagType": getType
						})
					}
					else if(setCourseData){
						mandatoryTags.forEach((mt:any,i:number)=>{
							tags.forEach((t:any,i:number)=>{
								
							if(mt._id == t._id && mt.content.type == getType){
								tagArray.push({
									"_id": t._id,
									"tagName": t.tagName,
									"value": t.value,
									"tagType": getType
								})
							}
						
							})
						})
						
					}
					break;

				case "listpickerMultiselect":
					var getElement = document.getElementById(flag + i) || event.currentTarget

					var getName = getElement.getAttribute("data-name")
					var getID = getElement.getAttribute("data-id")
					let listMultiValue = (document.getElementById(`hdn_${getID}`) as HTMLInputElement).value;

					if (listMultiValue != "") {
						tagArray.push({
							"_id": getID,
							"tagName": getName,
							"value": listMultiValue.split(","),
							"tagType": getType
						})
					}
					else if(setCourseData){
						mandatoryTags.forEach((mt:any,i:number)=>{
							tags.forEach((t:any,i:number)=>{
								
							if(mt._id == t._id && mt.content.type == getType){
								tagArray.push({
									"_id": t._id,
									"tagName": t.tagName,
									"value": t.value,
									"tagType": getType
								})
							}
						
							})
						})
						
					}
					break;
				default:
					var getElement = document.getElementById(flag + i) || event.currentTarget

					var getName = getElement.getAttribute("data-name")
					var getID = getElement.getAttribute("data-id")
					let listValue = (document.getElementById(`${getType}${getID}`) as HTMLInputElement).value;

					if (listValue != "") {
						tagArray.push({
							"_id": getID,
							"tagName": getName,
							"value": listValue,
							"tagType": getType
						})
					}
					else if(setCourseData){
						mandatoryTags.forEach((mt:any,i:number)=>{
							tags.forEach((t:any,i:number)=>{
								
							if(mt._id == t._id && mt.content.type == getType){
								tagArray.push({
									"_id": t._id,
									"tagName": t.tagName,
									"value": t.value,
									"tagType": getType
								})
							}
						
							})
						})
						
					}
					break;
			}
		}

		return tagArray
	}

	handleSubmit() {
		//e.preventDefault();
		var self = this;
		if (!self.validateSettings()) {
			return
		}
		let tagsData = this.getMandatoryTagsData(window.event, "mandatory");
		let uniqueTagsData:any[] = [];
		tagsData.forEach((data:any) => {
			const d = _.find(uniqueTagsData, ['_id', data._id]);
			if (_.isEmpty(d)) {
				uniqueTagsData.push(data);
			}
		})
		var optionalTagsData = this.getMandatoryTagsData(window.event, "optional")
		var getLength = document.getElementsByClassName("mandatory").length
		
		if (uniqueTagsData.length !== getLength) {
			self.props.showMsg('Please select mandatory tags.', 'error');
			return
		}
		tagsData = [...uniqueTagsData, ...optionalTagsData]
		let { courseDescription, coursePrice, purchaseEndDate, purchaseStartDate, languageSelected, checkAutoLogin, checkPublish, paidStatus } = this.state;
		const { batchesData } = this.props;
		var courseID = this.props.courseID || getCourseID()

		var parameter = {
			"isPublish": checkPublish.toString(),
			"isPayable": paidStatus == "Free" ? "false" : "true",
			"purchaseStartDate": purchaseStartDate,
			"purchaseEndDate": purchaseEndDate,
			"language": languageSelected,
			"price": paidStatus == "Free" ? 0 : parseFloat(coursePrice),
			"courseDescription": courseDescription,
			"isLogin": checkAutoLogin,
			"tags": tagsData,
			"batches": batchesData,
			"testTypes": this.state.testTypes
		}

		advancedSettingService.updateSettings(courseID, parameter).then((responseData: any) => {
			if (responseData.statusCode === 200) {
				if (!_.isEmpty(responseData.responseObject)) {
					self.props.showMsg("Settings Successfully Saved !", 'success');
					this.props.setCourseData(responseData.responseObject)
				}
			} else {
				self.props.showMsg(responseData.responseMessage, 'error');
			}
		});
	}

	handleTestTypeChange = (evt:any) => {
		this.setState({ testTypes: evt.target.value })
	};

	handleTestTypeOpen = () => {
		this.setState({ isTestTypeOpen: true })
	}

	handleTestTypeClose = () => {
		this.setState({ isTestTypeOpen: false })
	}


	render() {
		let {
			classes,
			previewMode,
			toggleInstructorBatchCard,
			instructorKey,
			instructorValue,
			cardDetails,
			setAddedBatchesData,
			batchesData,
			cardFlag,
			setCountSubjectRemove,
			subjectRemoved,
			testTemplateTypeList
		} = this.props;

		let { 
			paidStatus,
			checkAutoLogin,
			courseDescription,
			coursePrice,
			purchaseEndDate,
			purchaseStartDate,
			anchorEl,
			languageSelected,
			setCourseData,
			autoAssign
		} = this.state;

		var courseID = this.props.courseID || getCourseID();

		const languageOptions = [
			{ label: 'English', value: 'English' },
			{ label: 'Hindi', value: 'Hindi' },
		]
		
		const {  selectedTestTypeName } = this.state;
		let selectedTestTypes = [ ...this.state.testTypes];
		selectedTestTypes = selectedTestTypes.length<1 ? ["5ca1f0626960a4097b583cce"]:selectedTestTypes;
		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>

					<Grid item xs={12} className={classes.wrapperMain} style={{ marginTop: "20px" }}>
						<Typography variant="h6" style={{ padding: "10px" }}>
							Settings
					</Typography>
						<Grid container xs={12} className={cx(classes.wrapperMain, classes.borderDefault)}>

							<Typography variant="body2" style={{ lineHeight: "50px" }}>
								Publish on Glorifire.com
						</Typography>
							<Switch
								checked={this.state.checkPublish}
								onChange={this.handleChangePublish.bind(this)}
								value="publish"
								color="primary"
								 />

							<Grid item xs={12}>
								<RadioGroup
									aria-label="Gender"
									name="gender1"
									defaultValue="Free"
									value={paidStatus}
									onChange={this.handleChangePaidStatus.bind(this)}
									style={{ flexDirection: "row" }}
								>
									<FormControlLabel
										value="Free"
										control={<Radio />}
										label="Free" />
									<FormControlLabel
										style={{ marginLeft: "50px", fontSize: "28px" }}
										value="Paid"
										control={<Radio />}
										label="Paid" />
								</RadioGroup>
							</Grid>
							<div className={paidStatus == "Free" ? classes.hide : classes.show}>
								<Grid container
									spacing={16}
									alignItems="center"
									direction="row"
									justify="flex-start"
									onChange={this.handlePriceChanges.bind(this)}
									className={classes.marginTop10}>
									<Grid item >
										<Typography style={{ width: "150px" }} variant="body2">Course Price</Typography>
									</Grid>
									<Grid item>
										<MyPATTextField
											placeholder="Rs."
											variant="outlined"
											fullWidth margin="dense"
											value={coursePrice}
											style={{ width: '450px', marginLeft: "20px" }}
											InputLabelProps={{
												shrink: true,
												minLength: 3
											}}
										/>
									</Grid>
								</Grid>

								<Grid container
									spacing={16}
									alignItems="center"
									direction="row"
									onChange={this.handleStartDateChange.bind(this)}
									justify="flex-start"
									className={classes.marginTop10}>
									<Grid item >
										<Typography variant="body2">Purchase Start Date</Typography>
										<MyPATTextField
											id="datetime-local"
											type="date"
											value={purchaseStartDate}
											variant="outlined"
											fullWidth margin="dense"
											style={{ width: '400px' }}
											InputLabelProps={{
												shrink: true,
												minLength: 3
											}}
											startAdornment={
												<InputAdornment position="start">
													<DateIcon classes={{ root: classes.dateIcon }} />
												</InputAdornment>
											}
										/>
									</Grid>
									<Grid item >
										<Typography variant="body2">Purchase End Date</Typography>
										<MyPATTextField
											type="date"
											onChange={this.handleEndDateChange.bind(this)}
											variant="outlined"
											value={purchaseEndDate}
											fullWidth margin="dense"
											style={{ width: '440px' }}
											InputLabelProps={{
												shrink: true,
											}}
											startAdornment={
												<InputAdornment position="start">
													<DateIcon classes={{ root: classes.dateIcon }} />
												</InputAdornment>
											}
										/>
									</Grid>
								</Grid>
							</div>

							<Grid container 
								alignItems="center"
								direction="row"
								justify="flex-start"
								style={{ borderTop: "1px solid #DFDFDF", marginTop: "15px" }}
							>
								<Typography variant="body2"   style={{ lineHeight: "50px" }}>
									Enable Auto Assign 
									<Tooltip
										placement="right-start"
										title="Auto assign allows the users to unlock their own assignments
										if they have completed all the previous assignments in the sequence."
									>
										<InfoOutlined className={classes.ml1x} />
									</Tooltip>
								</Typography>
							
								<Switch
									checked={autoAssign}
									onChange={this.handleEnableLogin.bind(this)}
									value="enableLogin"
									color="primary" />
							</Grid>

							<Grid container
								spacing={16}
								alignItems="center"
								direction="row"
								justify="flex-start"
								className={classes.marginTop10}
								style={{ marginBottom: "30px" }}>
								<Grid item style={{ width: "80px" }}>
									<Typography variant="body2">Language*</Typography>
								</Grid>
								<Grid style={{ marginLeft: "46px" }}>
									<MyPATSelect
										multiple
										value={setCourseData ? languageSelected : ''}
										fullWidthControl
										onChange={this.handleLanguageChange.bind(this)}
										style={{ width: '350px' }}
									>	
										<option value="" disabled>Select Language</option>
										{_.map(languageOptions, (option:any, optionI:number) => (
											<option key={optionI} value={option.value}>{option.label}</option>
										))}

									</MyPATSelect>
								</Grid>
							</Grid>
						</Grid>
						
						<Grid container xs={12} className={cx(classes.wrapperMain, classes.borderDefault)}
						style={{ marginTop: "8px" }}>
							<Grid >
								<Typography variant="body2"   style={{ lineHeight: "50px" }}>
									Milestone Tests can only include
								</Typography>
							</Grid>

							<Grid container
								spacing={16}
								alignItems="center"
								direction="row"
								justify="flex-start"
								className={classes.marginTop10}
								style={{ marginBottom: "30px" }}>
								<Grid item style={{ width: "100%" ,marginTop:"-15px"}}>
									<Typography variant="body2">Select Test type from below</Typography>
								</Grid>
								<Grid style={{ marginLeft: "13px" }}>
									<Select
										multiple
										style={{minWidth: 300}}
										className={cx(`${classes.input} `)}
										open={this.state.isTestTypeOpen}
										onOpen={this.handleTestTypeOpen.bind(this)}
										onClose={this.handleTestTypeClose.bind(this)}
										value={selectedTestTypes}
										disableUnderline={true}
										onChange={this.handleTestTypeChange.bind(this)}
										input={<Input id="select-multiple-chip" />}
										renderValue={(selected:any) => (
											<div className={classes.chips}>
												{selected.map((value:any, index: number) => (
													<Chip
														key={`${value} ${index}`}
														label={_.get(_.find(testTemplateTypeList, ['_id', value]), 'name', '-')}
														className={classes.chip}
													/>
												))}
											</div>
										)}
										MenuProps={{
											getContentAnchorEl: null,
											anchorOrigin: {
												vertical: 'bottom',
												horizontal: 'left'
											}
										}}
									>
										
										{_.map(testTemplateTypeList, (option:any, optionI:number) => (
											<MenuItem
												key={`test_type_${optionI}`}
												style={{textTransform: 'capitalize'}}
												value={option._id}
											>
												<Checkbox checked={_.includes(selectedTestTypes, option._id)} />
												<ListItemText primary={option.name} />
											</MenuItem>
										))}

									</Select>
								</Grid>
								<Grid item xs={12}>
									<Button size="small" color="primary" onClick={this.handleTestTypeOpen.bind(this)}>
										+ Add More
          				</Button>
								</Grid>
							</Grid>
						</Grid>
						<TagsContent cardDetails = {cardDetails} setCourseData = {setCourseData}/>

						<Grid container xs={12} className={cx(classes.wrapperMain, classes.borderDefault, classes.marginTop10)}>
							<Typography variant="h6" style={{ padding: "10px" }}>
								Course Description
							</Typography>
							<MyPATTextArea
								inputId="milestoneObjective"
								name="milestoneObjective"
								placeholder="Describe the course, its objectives and general outline..."
								onChange={this.handleDescriptionChange.bind(this)}
								value={courseDescription}
								rows="5"
								multiline
								fullWidthControl
							/>
						</Grid>

						<BatchesSyllabusContent 
							addedBatches={batchesData}	
							toggleInstructorBatchCard={toggleInstructorBatchCard}
							setAddedBatchesContent={setAddedBatchesData}
							instructorKey={instructorKey}
							instructorValue={instructorValue}
							cardFlag={cardFlag}
							setCountSubjectRemove={setCountSubjectRemove}
							subjectRemoved={subjectRemoved}
						/>

						<Grid xs={12} container justify="flex-end" alignItems="flex-end">
							<ResponseBasedACL
								response={_.get(cardDetails, 'aclMetaData', {})}
								responseKey='allowedTo'
								accessType={['EDIT']}
							>
								<Button
									variant="contained"
									type="submit"
									color="primary"
									// disabled={previewMode ? true : false}
									onClick={this.handleSubmit}
									style={{ margin: "30px" }}
								>
									Save Settings
								</Button>
							</ResponseBasedACL>
						</Grid>
					</Grid>
				</Grid>
			</>
		)
	}
}

const mapStateToProps = (state:any) => {
	return {
		testTemplateTypeList: _.get(state, 'testTemplate.testTemplateType.list', []),
	}
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg,
		setCourseData: setCourseData,
		getTestTemplateType,
	},
	dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AdvanceSettingContent));
// @ts-ignore